import { Box, Typography } from '@mui/material';
import { ContentTile } from '@/graphql/__generated/sdk';
import { contentTileLinkStyles, contentTileImageStyles, contentTileImageAssetStyles, contentTileTextStyles, contentTileTitleStyles, contentTileDescriptionStyles, contentTileArrowIconStyles } from './HeaderContentTile.styles';
import ImageAsset, { IImage } from '@shared-components/components/ImageAsset/ImageAsset';
import TAGLink from '@shared-components/components/TAGLink';
import TAGSvgIcon from '@shared-components/components/TAGSvgIcon';
import { useAppContext, useFacilityContext, useOfficeLocationContext } from '@shared-components/context';
import { resolveEntryLink } from '@utils/resolveButtonEntryLink';
interface IHeaderContentTile {
  tile: ContentTile;
}
export default function HeaderContentTile({
  tile
}: Readonly<IHeaderContentTile>) {
  const {
    config
  } = useAppContext();
  const {
    officeInfo
  } = useFacilityContext();
  const {
    officeInfo: officeLocationInfo
  } = useOfficeLocationContext();
  const href = tile.internalPage ? resolveEntryLink({
    path: tile.internalPage.path ?? '',
    typeName: tile.internalPage.__typename as string,
    config,
    officeInfo,
    officeLocationInfo
  }) : tile.externalUrl ?? '#';
  return <TAGLink href={href} dataTestId={`link_content_tile_${tile.sys.id}`} linkSx={contentTileLinkStyles} data-sentry-element="TAGLink" data-sentry-component="HeaderContentTile" data-sentry-source-file="HeaderContentTile.tsx">
			<Box sx={contentTileImageStyles} data-sentry-element="Box" data-sentry-source-file="HeaderContentTile.tsx">
				{tile.image && <ImageAsset desktopImage={tile.image as IImage} alt={tile.title ?? ''} dataTestId={`img_content_tile_${tile.sys.id}`} imageSx={contentTileImageAssetStyles} />}
			</Box>
			<Box sx={contentTileTextStyles} data-sentry-element="Box" data-sentry-source-file="HeaderContentTile.tsx">
				{tile.title && <Typography variant="bodyMediumBold" sx={contentTileTitleStyles}>
						{tile.title}
					</Typography>}
				{tile.description && <Typography variant="bodySmallBook" sx={contentTileDescriptionStyles}>
						{tile.description}
					</Typography>}
			</Box>
			<Box sx={contentTileArrowIconStyles} data-sentry-element="Box" data-sentry-source-file="HeaderContentTile.tsx">
				<TAGSvgIcon icon="ChevronRightFunc" htmlColor="#282828" size={28} dataTestId={`icon_content_tile_arrow_${tile.sys.id}`} data-sentry-element="TAGSvgIcon" data-sentry-source-file="HeaderContentTile.tsx" />
			</Box>
		</TAGLink>;
}